module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold-slnt=0.65cbb751.ttf";